import { produce } from 'immer';
import { RestaurantState } from './restaurantModels';
import { restaurantActions } from './restaurantAction';
import { getOfferCategory, isExclusiveCoupon } from '../../utils/offer-utils';
import {
  RESTAURANT_DETAIL_REQUEST,
  RESTAURANT_DETAIL_SUCCESS,
  RESTAURANT_DETAIL_FAILURE,
  RESTAURANT_MENU_DETAIL_REQUEST,
  RESTAURANT_MENU_DETAIL_SUCCESS,
  RESTAURANT_MENU_DETAIL_FAILURE,
  FEEDBACK_DETAIL_REQUEST,
  FEEDBACK_DETAIL_SUCCESS,
  FEEDBACK_DETAIL_FAILURE,
  SUBMIT_FEEDBACK_DETAIL_REQUEST,
  SUBMIT_FEEDBACK_DETAIL_SUCCESS,
  SUBMIT_FEEDBACK_DETAIL_FAILURE,
  // STORE_MENU_ITEM,
  RESTAURANTS_SUCCESS,
  RESTAURANTS_REQUEST,
  RESTAURANTS_FAILURE,
  STORE_SELECTED_LOCATION,
  CLEAR_SELECTED_LOCATION,
  REFRESH_MENU_DETAIL,
  SERVING_RESTAURANTS_SUCCESS,
  RESTAURANT_DETAIL_LOCATION_ID_REQUEST,
  RESTAURANT_DETAIL_LOCATION_ID_SUCCESS,
  RESTAURANT_DETAIL_LOCATION_ID_CLEAR,
  ACTIVE_ORDER_RESTAURANT_REQUEST,
  ACTIVE_ORDER_RESTAURANT_SUCCESS,
  ACTIVE_ORDER_RESTAURANT_CLEAR,
  GET_MASTER_HOME_PAGE_DETAILS,
  GET_MASTER_HOME_PAGE_DETAILS_SUCCESS,
  GET_MASTER_HOME_PAGE_DETAILS_ERROR,
  CLEAR_RESTAURANT_DETAIL,
  CLEAR_FEEDBACK_DATA,
  GET_RESTAURANT_TABLE_DETAILS,
  GET_RESTAURANT_TABLE_DETAILS_FAILED,
  GET_RESTAURANT_TABLE_DETAILS_SUCCESS,
  RESTAURANT_ORDER_TYPE_SWITCH_SUCCESS,
  UPDATE_CD_GUEST_COUNT,
  RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE,
  UPDATE_RESTAURANT_STATUS,
  CURRENT_ORDERTYPE_ID,
  CURRENT_ORDER_TYPE,
  CURRENT_CUSTOMIZATION_ID,
  DELIVERY_ADDRESSES,
  SELECTED_DELIVERY_ADDRESS,
  ADD_ADDRESS_TAGS,
  ADD_DELIVERY_ADDRESS_REQUEST,
  ADD_DELIVERY_ADDRESS_SUCCESS,
  ADD_DELIVERY_ADDRESS_FAILURE,
  EDIT_DELIVERY_ADDRESS_REQUEST,
  EDIT_DELIVERY_ADDRESS_SUCCESS,
  EDIT_DELIVERY_ADDRESS_FAILURE,
  VIEW_DELIVERY_ADDRESS_REQUEST,
  VIEW_DELIVERY_ADDRESS_SUCCESS,
  VIEW_DELIVERY_ADDRESS_FAILURE,
  DELETE_DELIVERY_ADDRESS_REQUEST,
  DELETE_DELIVERY_ADDRESS_SUCCESS,
  DELETE_DELIVERY_ADDRESS_FAILURE,
  ADD_FAV_REQUEST,
  ADD_FAV_SUCCESS,
  ADD_FAV_FAILURE,
  REMOVE_FAV_REQUEST,
  REMOVE_FAV_SUCCESS,
  REMOVE_FAV_FAILURE,
  GET_FAV_REQUEST,
  GET_FAV_SUCCESS,
  GET_FAV_FAILURE,
  SET_FAV_MAP,
  UPDATE_FAV_MAP,
  SET_SELECTED_RESTAURANT_TAB, // Add this line
  SET_SELECTED_DELIVERY_TYPE,
  GET_EXPLORE_MENU_REQUEST,
  GET_EXPLORE_MENU_SUCCESS,
  GET_EXPLORE_MENU_FAILURE,
  REMOVE_DELIVERY_ADDRESS,
  IS_ANNOUNCEMENT_OPEN,
  TOGGLE_CLICK,
  RESET_RESTAURANT,
  UPDATE_CURRENT_ACTIVE_MENU,
  IS_EXPLORE_TAB_ACTIVE,
  TOGGLE_STATUS,
  GET_COUPONS_REQUEST,
  GET_COUPONS_SUCCESS,
  GET_COUPONS_FALIURE,
  VALIDATE_COUPONS_REQUEST,
  VALIDATE_COUPONS_FALIURE,
  VALIDATE_COUPONS_SUCCESS,
  REDEEM_COUPONS_REQUEST,
  REDEEM_COUPONS_SUCCESS,
  REDEEM_COUPONS_FALIURE,
  APPLIED_COUPON,
  CLEAR_APPLIED_COUPON,
  VALIDATE_COUPONS_MSG_CLEAR,
  VALIDATE_COUPONS_FALIURE_MESSAGE,
} from './restaurantContants';

let restaurantData = {
  id: '',
  branchName: '',
  address: '',
  open: 1,
  city: '',
  country: '',
  delivery: 0,
  branch: [],
  media: [],
  rating: 0,
  phoneNumber: '',
  cost: '', // 200-2
  digitalMenu: 0,
  highChair: 0,
  dining: 0,
  takeAway: 0,
  onlineCheckin: 0,
  onlineOrder: 0,
  parking: [],
  cards: [],
  pref: [],
  tableSection: [],
  safetyMeasures: [],
  workingHours: [],
  currentWorkingHours: [],
  facilities: [],
  cuisine: null,
  diets: [],
  itemTypes: [],
  maxCheckinWaitThreshold: 0,
  maxOnlineCheckin: 0,
  redirectUrl: '',
  orderTypes: null,
  defaultPickUpETA: 0,
  paymentProvider: null,
  deliveryKMRadius: null,
  locationDeliveryProviders: null,

  // Scheduled delivery
  scheduledDelivery: 0,
  scheduledDeliveryCutOffTime: '',
  scheduledDeliveryDurationInDays: '',

  locationSlug: '',
  disabledServices: null,
  cancellationPolicy: null,
  deliverySettings: null,
  platformConfiguration: null,
  aboutUs: null,
  merchantSlug: '',
  pickupCutoff: null,
  defaultTax: null,
  quickCheckIn: 0,
  shareTable: 0,
  deliveryCutOffTimeExceeds: 0,
  pickupCutOffTimeExceeds: 0,
  defaultDeliveryETA: 0,
  timeZoneCd: '',
  assignTableDuringQuickCheckIn: 0,

  dataCapCnpPayment: false,
  isSurchargeEnabled: false,

  activeSessionEndTime: null,
  nextSession: null,
  isLastActiveSession: false,

  themeColor: null,
};

const initialRestaurantState: RestaurantState = {
  // Location Based Restaurants
  currentLocation: null,
  currentLocationRestaurants: [],
  currentServingLocations: [],
  currentLocationRestaurantsLoading: false,
  restaurantDefaultTax: null,

  // Restaurant Details
  currentRestaurantDetail: restaurantData,
  activeSessionEndTime: '',
  currentRestaurantSlug: '',
  currentMerchantType: '',
  currentMenuType: '',
  restaurantDetailLoading: false,
  restaurantDetailsSuccess: false,
  restaurantDetailsFailure: false,
  restaurantDetailFailMessage: '',
  restaurantOrderTypeId: '', // ID for PickUp / Delivery / ..
  restaurantCurrentMenuType: '',
  currentOrderTypeid: '',
  currentOrderType: '',
  customizationId: '',
  restaurantMenuSuccess: false,
  // Pickup / Delivery
  restaurantMenuDetails: [],
  IngredientItemfilter: [],
  restaurantMenuCategories: [],
  restaurantSectionTypes: [],
  restaurantOrderTax: [],
  restaurantMenuDetailLoading: false,
  restaurantMenuDetailFailure: false,
  restaurantMenuDetailFailMessage: '',
  refreshMenuDetails: false,

  //Feedback state
  FeedbackQuestions: [],
  feedbackDetailLoading: false,
  feedbackDetailFailMessage: '',
  //Submitfeedback state
  SubmitFeedbackDetails: [],
  submitFeedbackDetailLoading: false,
  submitFeedbackDetailFailMessage: '',
  feedbackSubmitted: false,
  summaryOrderRestaurantLoading: false,

  isAnnouncementOpen: false,
  //Active Order Restaurant Details
  activeOrderRestaurantDetails: {
    id: '',
    branchName: '',
    address: '',
    open: 1,
    city: '',
    country: '',
    delivery: 0,
    branch: [],
    media: [],
    rating: 0,
    phoneNumber: '',
    cost: '', // 200-2
    digitalMenu: 0,
    highChair: 0,
    dining: 0,
    takeAway: 0,
    onlineCheckin: 0,
    onlineOrder: 0,
    parking: [],
    cards: [],
    pref: [],
    tableSection: [],
    safetyMeasures: [],
    workingHours: [],
    currentWorkingHours: [],
    facilities: [],
    cuisine: null,
    diets: [],
    itemTypes: [],
    maxCheckinWaitThreshold: 0,
    maxOnlineCheckin: 0,
    redirectUrl: '',
    orderTypes: null,
    defaultPickUpETA: 0,
    paymentProvider: null,
    deliveryKMRadius: null,
    locationDeliveryProviders: null,

    // Scheduled delivery
    scheduledDelivery: 0,
    scheduledDeliveryCutOffTime: '',
    scheduledDeliveryDurationInDays: '',

    locationSlug: '',
    disabledServices: null,
    cancellationPolicy: null,
    deliverySettings: null,
    platformConfiguration: null,
    aboutUs: null,
    merchantSlug: '',
    pickupCutoff: null,
    defaultTax: null,
    quickCheckIn: 0,
    shareTable: 0,
    deliveryCutOffTimeExceeds: 0,
    pickupCutOffTimeExceeds: 0,
    defaultDeliveryETA: 0,
    timeZoneCd: '',
    assignTableDuringQuickCheckIn: 0,

    dataCapCnpPayment: false,
    isSurchargeEnabled: false,

    activeSessionEndTime: null,
    nextSession: null,
    isLastActiveSession: false,

    themeColor: null,

    selectedAddress: [],
    deliveryAddress: [],
    deliveryAddressLoading: false,
    addDeliveryAddressLoading: true,
    editDeliveryAddressLoading: true,
    deliveryAddressSuccess: false,
    deliveryAddressFailure: false,
    addDeliveryAddressFailure: false,
    deliveryAddressFailureMessage: null,
    deliveryMessage: '',
    deleleteDeliveryId: '',
  },

  activeOrderRestaurantLoading: false,
  masterRestaurantHomePageDetails: {
    id: '',
    branchName: '',
    address: '',
    open: 1,
    city: '',
    country: '',
    delivery: 0,
    branch: [],
    media: [],
    rating: 0,
    phoneNumber: '',
    cost: '', // 200-2
    digitalMenu: 0,
    highChair: 0,
    dining: 0,
    takeAway: 0,
    onlineCheckin: 0,
    onlineOrder: 0,
    parking: [],
    cards: [],
    pref: [],
    tableSection: [],
    safetyMeasures: [],
    workingHours: [],
    currentWorkingHours: [],
    facilities: [],
    cuisine: null,
    diets: [],
    itemTypes: [],
    maxCheckinWaitThreshold: 0,
    maxOnlineCheckin: 0,
    redirectUrl: '',
    orderTypes: null,
    defaultPickUpETA: 0,
    paymentProvider: null,
    deliveryKMRadius: null,
    locationDeliveryProviders: null,

    // Scheduled delivery
    scheduledDelivery: 0,
    scheduledDeliveryCutOffTime: '',
    scheduledDeliveryDurationInDays: '',

    locationSlug: '',
    disabledServices: null,
    cancellationPolicy: null,
    deliverySettings: null,
    platformConfiguration: null,
    aboutUs: null,
    merchantSlug: '',
    pickupCutoff: null,
    defaultTax: null,
    quickCheckIn: 0,
    shareTable: 0,
    deliveryCutOffTimeExceeds: 0,
    pickupCutOffTimeExceeds: 0,
    defaultDeliveryETA: 0,
    timeZoneCd: '',
    assignTableDuringQuickCheckIn: 0,

    dataCapCnpPayment: false,
    isSurchargeEnabled: false,

    activeSessionEndTime: null,
    nextSession: null,
    isLastActiveSession: false,

    themeColor: null,
  },
  masterRestaurantHomePageDetailsloading: false,
  masterRestaurantHomePageDetailsSuccess: false,
  restaurantTableDetailsLoading: false,
  restaurantTableDetailsFailed: false,
  restaurantTableDetailsSuccess: false,
  restaurantTableDetails: [],

  categoryMTypes: [],
  subCategoryMTypes: [],
  eventSlot: {},
  eventOrderSlot: [],

  cdGuestCount: 0,
  currentResCountry: '',
  //deleivery Addresses
  DeliveryAddress: [],
  selectedDeliveryAddress: {},
  addressTags: ['Custom'],
  addFavLoading: false,
  addFavSuccess: false,
  addFavFailure: false,
  lastUpdatedItemId: null,
  removeFavLoading: false,
  removeFavSuccess: false,
  removeFavFailure: false,
  getFavLoading: false,
  getFavSuccess: false,
  getFavFailure: false,
  getFav: [],
  favMap: {},
  selectedRestaurantTab: 'menu',
  selectedDeliveryType: 'Delivery',

  //explore menu
  exploreMenu: [],
  exploreMenuLoading: false,
  exploreMenuSuccess: false,
  exploreMenuFailure: false,
  toggleClick: false,
  currentActivMenuType: null,
  isExploretabActive: false,
  ToggleStatus: {
    onlyAvailable: true,
    nonVegetarian: false,
    vegetarian: false,
  },
  selectedIngredientChecklist: [],
  //coupon
  appliedCoupons: [] as any[],
  getCouponData: [],
  getCouponLoading: false,
  getCouponSuccess: false,
  getCouponFaliure: false,
  validateCouponmsg: '',
  validateCouponLoading: false,
  validateCouponSuccess: false,
  validateCouponFaliure: false,
  promoLoaderStopCount: 0,
  redeemCouponLoading: false,
  redeemCouponSuccess: false,
  redeemCouponFaliure: false,
};

export default function restaurantReducer(
  state: RestaurantState = initialRestaurantState,
  action: restaurantActions
) {
  return produce(state, draft => {
    switch (action.type) {
      case RESET_RESTAURANT:
        draft.SubmitFeedbackDetails = [];
        draft.submitFeedbackDetailLoading = false;
        draft.submitFeedbackDetailFailMessage = '';
        draft.feedbackSubmitted = false;
        draft.DeliveryAddress = [];
        draft.selectedDeliveryAddress = {};
        draft.addressTags = ['Custom'];
        draft.addFavLoading = false;
        draft.addFavSuccess = false;
        draft.addFavFailure = false;
        draft.lastUpdatedItemId = null;
        draft.removeFavLoading = false;
        draft.removeFavSuccess = false;
        draft.removeFavFailure = false;
        draft.getFavLoading = false;
        draft.getFavSuccess = false;
        draft.getFavFailure = false;
        draft.getFav = [];
        draft.favMap = {};
        draft.cdGuestCount = 0;
        // Object.assign(draft, initialRestaurantState);
        break;
      case STORE_SELECTED_LOCATION:
        draft.currentLocation = action.payload;
        break;
      case CLEAR_SELECTED_LOCATION:
        draft.currentLocation = null;
        break;

      case TOGGLE_CLICK:
        draft.toggleClick = true;
        break;
      case RESTAURANTS_REQUEST:
        draft.currentLocationRestaurants = [];
        draft.currentLocationRestaurantsLoading = true;
        break;
      case RESTAURANTS_SUCCESS:
        draft.currentLocationRestaurants = action.payload;
        draft.currentLocationRestaurantsLoading = false;
        break;
      case RESTAURANTS_FAILURE:
        draft.currentLocationRestaurants = [];
        draft.currentLocationRestaurantsLoading = false;
        break;
      case SERVING_RESTAURANTS_SUCCESS:
        draft.currentServingLocations = action.payload;
        break;
      case RESTAURANT_DETAIL_LOCATION_ID_REQUEST:
        // draft.restaurantDetailLoading = true;
        draft.currentRestaurantDetail.id = action.payload.locationId;
        if (action.payload.merchantType) {
          draft.currentMerchantType = action.payload.merchantType;
          draft.restaurantMenuDetails = [];
        }
        if (action?.payload?.isEventOrder) {
          draft.currentRestaurantDetail.open = 1;
        }
        draft.currentResCountry = '';
        break;
      case RESTAURANT_DETAIL_LOCATION_ID_SUCCESS:
        draft.restaurantDetailsSuccess = true;
        // draft.restaurantDetailLoading = false;

        draft.currentRestaurantDetail = action.payload.details;
        draft.currentResCountry = action.payload.details.country;
        draft.currentRestaurantDetail.isProductCatalogV2Enabled = true;
        if (action?.payload?.isEventOrder) {
          draft.currentRestaurantDetail.open = 1;
        }
        break;
      case RESTAURANT_DETAIL_LOCATION_ID_CLEAR:
        draft.restaurantDetailLoading = false;
        draft.restaurantDetailsSuccess = false;
        draft.currentResCountry = '';
        draft.currentRestaurantDetail = restaurantData;
        if ((action?.payload as any)?.isEventOrder) {
          draft.currentRestaurantDetail.open = 1;
        }
        break;
      case RESTAURANT_DETAIL_REQUEST:
        if (action.payload?.render) {
          break;
        }
        draft.restaurantDetailLoading = true;
        draft.restaurantDetailsSuccess = false;
        draft.restaurantDetailsFailure = false;
        draft.currentRestaurantSlug = action.payload.slug;
        draft.activeSessionEndTime = '';
        draft.currentResCountry = '';
        if (action.payload.merchantType) {
          draft.currentMerchantType = action.payload.merchantType;
          draft.restaurantMenuDetails = [];
        }
        draft.currentRestaurantDetail = restaurantData;
        // draft.currentRestaurantDetail.id = "";
        break;
      case RESTAURANT_DETAIL_SUCCESS:
        draft.restaurantDetailLoading = false;
        draft.restaurantDetailsSuccess = true;
        draft.restaurantDetailsFailure = false;
        draft.currentRestaurantDetail = action.payload.detail;
        draft.activeSessionEndTime = action.payload.detail.activeSessionEndTime;
        draft.currentResCountry = action.payload.detail.country;
        draft.currentRestaurantDetail.themeColor = action.payload.detail.theme;
        draft.currentRestaurantDetail.isProductCatalogV2Enabled = true;
        if (action?.payload?.isEventOrder) {
          draft.currentRestaurantDetail.open = 1;
        }
        break;
      case RESTAURANT_DETAIL_FAILURE:
        draft.activeSessionEndTime = '';
        draft.restaurantDetailLoading = false;
        draft.restaurantDetailsSuccess = false;
        draft.restaurantDetailsFailure = true;
        draft.restaurantDetailFailMessage = action.payload.message;
        draft.currentResCountry = '';
        break;
      // Restaurant Menu Details
      case REFRESH_MENU_DETAIL:
        draft.refreshMenuDetails = !draft.refreshMenuDetails;
        break;
      case RESTAURANT_MENU_DETAIL_REQUEST:
      case RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE:
        if (action.payload.render) {
          break;
        }
        draft.restaurantCurrentMenuType = action.payload.type;
        draft.restaurantMenuDetailLoading = true;
        draft.getFav = [];
        if (action.payload.type !== draft.currentMenuType) {
          draft.restaurantMenuDetails = [];
        }
        draft.currentMenuType = action.payload.type;
        draft.categoryMTypes = [];
        draft.subCategoryMTypes = [];
        draft.restaurantMenuSuccess = false;
        draft.restaurantMenuDetailFailure = false;
        break;
      case RESTAURANT_MENU_DETAIL_SUCCESS:
        draft.restaurantMenuDetailLoading = false;
      
        
        draft.restaurantMenuDetails = action.payload.menu;
        draft.restaurantOrderTypeId = action.payload.orderTypeId;
        draft.restaurantMenuCategories = action.payload.availableCategory;
        draft.restaurantSectionTypes = action.payload.sectionTypes;
        draft.restaurantOrderTax = action.payload.orderTax;
        
        draft.categoryMTypes = action.payload.categoryTypes;
        draft.subCategoryMTypes = action.payload.subCategoryTypes;
        draft.eventSlot = action?.payload?.eventSlot;
        draft.eventOrderSlot = action?.payload?.eventOrderSlot || [];
        draft.restaurantMenuSuccess = true;
        draft.restaurantMenuDetailFailure = false;
        const itemFilterSetId = new Set();
        const itemFilterTemp: any = [];

        action.payload.menu.forEach((item: any) => {
          if (item.diet) {
            item.diet.forEach((dietItem: any) => {
              if (dietItem && !itemFilterSetId.has(dietItem.id)) {
                itemFilterSetId.add(dietItem.id);
                itemFilterTemp.push(dietItem);
              }
            });
          }
        });

        draft.IngredientItemfilter = itemFilterTemp;
        break;
      case RESTAURANT_ORDER_TYPE_SWITCH_SUCCESS:
        draft.restaurantMenuDetailLoading = false;
        draft.restaurantMenuDetails = action.payload.typeName;
        draft.restaurantOrderTypeId = action.payload.id;
        draft.restaurantMenuSuccess = true;
        draft.restaurantMenuDetailFailure = false;
        // draft.restaurantMenuCategories = action.payload.availableCategory;
        // draft.restaurantSectionTypes = action.payload.sectionTypes;
        // draft.restaurantOrderTax = action.payload.orderTax;
        break;
      case CLEAR_RESTAURANT_DETAIL:
        draft.restaurantMenuDetailLoading = false;
        draft.restaurantMenuDetails = [];
        draft.restaurantOrderTypeId = '';
        draft.restaurantMenuSuccess = false;
        draft.restaurantMenuCategories = [];
        draft.restaurantSectionTypes = [];
        draft.restaurantOrderTax = [];
        break;

      case RESTAURANT_MENU_DETAIL_FAILURE:
        draft.restaurantMenuDetailLoading = false;
        draft.restaurantMenuDetailFailMessage = action.payload.message;
        draft.restaurantMenuDetails = [];
        draft.restaurantOrderTypeId = '';
        draft.restaurantMenuCategories = [];
        draft.restaurantSectionTypes = [];
        draft.restaurantOrderTax = [];
        draft.restaurantMenuSuccess = false;
        draft.restaurantMenuDetailFailure = true;
        break;

      case DELIVERY_ADDRESSES:
        draft.DeliveryAddress = action.payload;
        break;

      case CURRENT_ORDERTYPE_ID:
        draft.currentOrderTypeid = action.payload;
        break;
      case CURRENT_ORDER_TYPE:
        draft.currentOrderType = action.payload;
        break;

      case SELECTED_DELIVERY_ADDRESS:
        draft.selectedDeliveryAddress = action.payload;
        break;
      case ADD_ADDRESS_TAGS:
        draft.addressTags = action.payload;
        break;
      case CURRENT_CUSTOMIZATION_ID:
        draft.customizationId = action.payload;
        break;

      // Get Feedback Details
      case FEEDBACK_DETAIL_REQUEST:
        draft.feedbackDetailLoading = true;
        draft.feedbackSubmitted = false;
        break;
      case FEEDBACK_DETAIL_SUCCESS:
        draft.feedbackDetailLoading = false;
        draft.FeedbackQuestions = action.payload;
        break;
      case FEEDBACK_DETAIL_FAILURE:
        draft.feedbackDetailLoading = false;
        draft.feedbackDetailFailMessage = action.payload;
        break;

      case CLEAR_FEEDBACK_DATA:
        draft.feedbackDetailLoading = false;
        draft.feedbackSubmitted = false;
        draft.submitFeedbackDetailLoading = false;
        draft.submitFeedbackDetailFailMessage = '';
        break;
      //submitFeedback
      case SUBMIT_FEEDBACK_DETAIL_REQUEST:
        draft.submitFeedbackDetailLoading = true;
        draft.feedbackSubmitted = false;
        break;
      case SUBMIT_FEEDBACK_DETAIL_SUCCESS:
        draft.submitFeedbackDetailLoading = false;
        draft.feedbackSubmitted = true;
        break;
      case SUBMIT_FEEDBACK_DETAIL_FAILURE:
        draft.submitFeedbackDetailLoading = false;
        draft.submitFeedbackDetailFailMessage = action.payload;
        draft.feedbackSubmitted = false;
        break;
      case UPDATE_RESTAURANT_STATUS:
        draft.summaryOrderRestaurantLoading = action.payload;
        break;
      //Active Order Restaurants
      case ACTIVE_ORDER_RESTAURANT_REQUEST:
        draft.activeOrderRestaurantLoading = true;
        draft.activeOrderRestaurantSuccess = false;
        draft.activeOrderRestaurantDetails = null;
        draft.currentResCountry = '';
        break;
      case ACTIVE_ORDER_RESTAURANT_SUCCESS:
        draft.activeOrderRestaurantDetails = action.payload;
        draft.currentResCountry = action.payload.country;
        draft.activeOrderRestaurantLoading = false;
        draft.activeOrderRestaurantSuccess = true;
        //draft.summaryOrderRestaurantLoading = false;
        break;
      case ACTIVE_ORDER_RESTAURANT_CLEAR:
        draft.activeOrderRestaurantDetails = null;
        draft.activeOrderRestaurantLoading = false;
        draft.activeOrderRestaurantSuccess = false;
        draft.currentResCountry = '';
        break;

      // Get Master restaurant home page getails
      case GET_MASTER_HOME_PAGE_DETAILS:
        draft.masterRestaurantHomePageDetailsloading = true;
        draft.masterRestaurantHomePageDetailsSuccess = false;
        break;
      case GET_MASTER_HOME_PAGE_DETAILS_SUCCESS:
        draft.masterRestaurantHomePageDetails = action.payload;
        draft.masterRestaurantHomePageDetailsloading = false;
        draft.masterRestaurantHomePageDetailsSuccess = true;
        break;
      case GET_MASTER_HOME_PAGE_DETAILS_ERROR:
        draft.masterRestaurantHomePageDetailsloading = false;
        draft.masterRestaurantHomePageDetailsSuccess = false;
        break;

      // Get Restaurant Table Details
      case GET_RESTAURANT_TABLE_DETAILS:
        draft.restaurantTableDetailsLoading = true;
        draft.restaurantTableDetailsFailed = false;
        draft.restaurantTableDetailsSuccess = false;
        draft.restaurantTableDetails = [];
        break;
      case GET_RESTAURANT_TABLE_DETAILS_SUCCESS:
        draft.restaurantTableDetailsLoading = false;
        draft.restaurantTableDetailsFailed = false;
        draft.restaurantTableDetailsSuccess = true;
        draft.restaurantTableDetails = action.payload;
        break;
      case GET_RESTAURANT_TABLE_DETAILS_FAILED:
        draft.restaurantTableDetailsLoading = false;
        draft.restaurantTableDetailsFailed = true;
        draft.restaurantTableDetailsSuccess = false;
        draft.restaurantTableDetails = [];
        break;

      case UPDATE_CD_GUEST_COUNT:
        draft.cdGuestCount = action.payload;
        break;

      //Add Delivery address
      case ADD_DELIVERY_ADDRESS_REQUEST:
        draft.selectedAddress = action.payload;
        draft.deliveryAddressFailure = false;
        draft.addDeliveryAddressLoading = true;
        draft.deliveryAddressSuccess = false;
        draft.addDeliveryAddressFailure = false;
        break;

      case ADD_DELIVERY_ADDRESS_SUCCESS:
        draft.selectedAddress = [];
        draft.deliveryAddressFailure = false;
        draft.addDeliveryAddressLoading = false;
        draft.addDeliveryAddressFailure = false;
        draft.deliveryAddressSuccess = true;
        break;

      case ADD_DELIVERY_ADDRESS_FAILURE:
        draft.selectedAddress = [];
        draft.deliveryAddressFailure = true;
        draft.addDeliveryAddressLoading = false;
        draft.deliveryAddressSuccess = false;
        draft.addDeliveryAddressFailure = true;
        draft.deliveryAddressFailureMessage = action.payload;
        break;

      case EDIT_DELIVERY_ADDRESS_REQUEST:
        draft.selectedAddress = action.payload;
        draft.deliveryAddressFailure = false;
        draft.editDeliveryAddressLoading = true;
        draft.deliveryAddressSuccess = false;
        draft.deliveryMessage = '';
        break;

      case EDIT_DELIVERY_ADDRESS_SUCCESS:
        draft.selectedAddress = [];
        draft.deliveryAddressFailure = false;
        draft.editDeliveryAddressLoading = false;
        draft.deliveryAddressSuccess = true;
        draft.deliveryMessage = action.payload;
        break;

      case EDIT_DELIVERY_ADDRESS_FAILURE:
        draft.selectedAddress = [];
        draft.deliveryAddressFailure = true;
        draft.editDeliveryAddressLoading = false;
        draft.deliveryAddressSuccess = false;
        draft.deliveryAddressFailureMessage = action.payload;
        break;

      case VIEW_DELIVERY_ADDRESS_REQUEST:
        draft.deliveryAddress = [];
        draft.deliveryAddressFailure = false;
        draft.deliveryAddressLoading = true;
        draft.deliveryAddressSuccess = false;
        draft.deliveryMessage = '';
        break;

      case VIEW_DELIVERY_ADDRESS_SUCCESS:
        draft.deliveryAddress = action.payload;
        draft.deliveryAddressFailure = false;
        draft.deliveryAddressLoading = false;
        draft.deliveryAddressSuccess = true;
        draft.deliveryMessage = '';
        break;

      case VIEW_DELIVERY_ADDRESS_FAILURE:
        draft.deliveryAddressFailure = true;
        draft.deliveryAddressLoading = false;
        draft.deliveryAddressSuccess = false;
        draft.deliveryMessage = action.payload;
        break;

      case DELETE_DELIVERY_ADDRESS_REQUEST:
        draft.deleleteDeliveryId = action.payload;
        draft.deliveryAddressFailure = false;
        // draft.deliveryAddressLoading = true;
        draft.deliveryAddressSuccess = false;
        draft.deliveryMessage = '';
        const selctedaddress = draft.selectedDeliveryAddress.id === action.payload;
        if (selctedaddress) {
          draft.selectedDeliveryAddress = {};
        }
        break;

      case DELETE_DELIVERY_ADDRESS_SUCCESS:
        draft.deliveryAddressFailure = false;
        draft.deliveryAddressLoading = false;
        draft.deliveryAddressSuccess = true;
        const tempAddress = draft.deliveryAddress.addresses?.filter((address: any) => {
          return address?.id !== draft.deleleteDeliveryId;
        });
        draft.deliveryAddress.addresses = tempAddress;
        draft.deliveryMessage = action.payload;
        break;

      case DELETE_DELIVERY_ADDRESS_FAILURE:
        draft.deliveryAddressFailure = true;
        draft.deliveryAddressLoading = false;
        draft.deliveryAddressSuccess = false;
        draft.deliveryMessage = action.payload;
        break;

      case REMOVE_DELIVERY_ADDRESS:
        draft.deliveryAddress = [];
        draft.selectedDeliveryAddress = {};
        break;
      case ADD_FAV_REQUEST:
        draft.addFavLoading = true;
        draft.addFavSuccess = false;
        draft.addFavFailure = false;
        draft.lastUpdatedItemId = action.meta?.itemId || null;
        break;
      case ADD_FAV_SUCCESS:
        draft.addFavLoading = false;
        draft.addFavSuccess = true;
        draft.addFavFailure = false;
        break;
      case ADD_FAV_FAILURE:
        draft.addFavLoading = false;
        draft.addFavSuccess = false;
        draft.addFavFailure = true;
        draft.lastUpdatedItemId = (action as any)?.meta?.itemId || null;
        break;
      case REMOVE_FAV_REQUEST:
        draft.removeFavLoading = true;
        draft.removeFavSuccess = false;
        draft.removeFavFailure = false;
        draft.lastUpdatedItemId = action.meta?.itemId || null;
        break;
      case REMOVE_FAV_SUCCESS:
        draft.removeFavLoading = false;
        draft.removeFavSuccess = true;
        draft.removeFavFailure = false;
        break;
      case REMOVE_FAV_FAILURE:
        draft.removeFavLoading = false;
        draft.removeFavSuccess = false;
        draft.removeFavFailure = true;
        draft.lastUpdatedItemId = (action as any)?.meta?.itemId || null;
        break;
      case GET_FAV_REQUEST:
        draft.getFavLoading = true;
        draft.getFavSuccess = false;
        draft.getFavFailure = false;
        draft.getFav = [];
        break;
      case GET_FAV_SUCCESS:
        draft.getFavLoading = false;
        draft.getFavSuccess = true;
        draft.getFavFailure = false;
        draft.getFav = action.payload;
        const newFavMap: Record<string, boolean> = {};
        action.payload.forEach((item: any) => {
          newFavMap[item.itemId] = true;
        });
        draft.favMap = newFavMap;
        break;
      case GET_FAV_FAILURE:
        draft.getFavLoading = false;
        draft.getFavSuccess = false;
        draft.getFavFailure = true;
        draft.getFav = [];
        break;

      case 'RESET_FAV_STATUS':
        draft.addFavSuccess = false;
        draft.removeFavSuccess = false;
        draft.lastUpdatedItemId = null;
        break;
      case SET_FAV_MAP:
        draft.favMap = action.payload;
        break;
      case UPDATE_FAV_MAP:
        const { itemId, isFav } = action.payload;
        if (!draft.favMap) {
          draft.favMap = {};
        }
        draft.favMap[itemId] = isFav;
        break;
      case SET_SELECTED_RESTAURANT_TAB:
        draft.selectedRestaurantTab = action.payload;
        break;

      case SET_SELECTED_DELIVERY_TYPE:
        draft.selectedDeliveryType = action.payload;
        break;

      case GET_EXPLORE_MENU_REQUEST:
        draft.exploreMenu = [];
        draft.exploreMenuLoading = true;
        draft.exploreMenuSuccess = false;
        draft.exploreMenuFailure = false;
        break;

      case GET_EXPLORE_MENU_SUCCESS:
        draft.exploreMenu = action.payload;
        draft.exploreMenuLoading = false;
        draft.exploreMenuSuccess = true;
        draft.exploreMenuFailure = false;
        break;

      case GET_EXPLORE_MENU_FAILURE:
        draft.exploreMenu = [];
        draft.exploreMenuLoading = false;
        draft.exploreMenuSuccess = false;
        draft.exploreMenuFailure = true;
        break;

      case UPDATE_CURRENT_ACTIVE_MENU:
        draft.currentActivMenuType = action.payload;
        break;

      case IS_ANNOUNCEMENT_OPEN:
        draft.isAnnouncementOpen = true;
        break;

      case IS_EXPLORE_TAB_ACTIVE:
        draft.isExploretabActive = action.payload;
        break;

      case TOGGLE_STATUS:
        draft.ToggleStatus = action.payload;
        break;

      case 'SELECTED_INGREDIENT_CHECKLIST':
        draft.selectedIngredientChecklist = action.payload || [];
        break;
      // coupon
      case GET_COUPONS_REQUEST:
        draft.getCouponLoading = true;
        draft.getCouponSuccess = false;
        draft.getCouponFaliure = false;
        draft.getCouponData = [];
        break;
      case GET_COUPONS_SUCCESS:
        draft.getCouponLoading = false;
        draft.getCouponSuccess = true;
        draft.getCouponFaliure = false;
         draft.getCouponData = action.payload;
        break;
      case GET_COUPONS_FALIURE:
        draft.getCouponLoading = false;
        draft.getCouponSuccess = false;
        draft.getCouponFaliure = true;
          draft.getCouponData = [];
        break;

        case VALIDATE_COUPONS_REQUEST:
        draft.validateCouponLoading = true;
        draft.validateCouponSuccess = false;
        draft.validateCouponFaliure = false;
        draft.validateCouponmsg = '';
        break;
      case VALIDATE_COUPONS_SUCCESS:
        draft.validateCouponLoading = false;
        draft.validateCouponSuccess = true;
        draft.validateCouponFaliure = false;
        draft.validateCouponmsg = action.payload;
        break;
      case VALIDATE_COUPONS_FALIURE:
        draft.validateCouponLoading = false;
        draft.validateCouponSuccess = false;
        draft.validateCouponFaliure = true;
        draft.validateCouponmsg = '';
        draft.promoLoaderStopCount = (draft.promoLoaderStopCount || 0) + 1;
        break;
      
      case VALIDATE_COUPONS_FALIURE_MESSAGE:
        draft.validateCouponmsg = action.payload;
        break;

      case VALIDATE_COUPONS_MSG_CLEAR:
        draft.validateCouponLoading = true;
        draft.validateCouponSuccess = false;
        draft.validateCouponFaliure = false;
        draft.validateCouponmsg = '';
        break;

        case REDEEM_COUPONS_REQUEST:
        draft.redeemCouponLoading = true;
        draft.redeemCouponSuccess = false;
        draft.redeemCouponFaliure = false;
      
        break;
      case REDEEM_COUPONS_SUCCESS:
        draft.redeemCouponLoading = false;
        draft.redeemCouponSuccess = true;
        draft.redeemCouponFaliure = false;
        
        break;
      case REDEEM_COUPONS_FALIURE:
        draft.redeemCouponLoading = false;
        draft.redeemCouponSuccess = false;
        draft.redeemCouponFaliure = true;
        
        break;


         case APPLIED_COUPON: {
        const incoming = action.payload;
        if (!incoming || typeof incoming !== 'object') break;
        const existing = Array.isArray(draft.appliedCoupons) ? draft.appliedCoupons : [];
        const incomingCat = getOfferCategory(incoming);

        // Exclusivity: combineOffer === true (v2 menu) means the coupon
        // cannot coexist with any other — except FREE_ITEM, which (like
        // item-level offers) always coexists regardless of exclusivity.
        //   - If incoming is exclusive → it replaces everything but keeps
        //     any existing FREE_ITEM coupon.
        //   - If any existing is exclusive → silently drop the new (non-exclusive)
        //     application; callers should check before dispatching.
        //   - Re-applying the same coupon by id is always allowed (acts as an
        //     update, e.g. updating _chosenFreeItemId on a FREE_ITEM coupon).
        if (isExclusiveCoupon(incoming)) {
          const existingFreeItem = existing.find((c: any) => getOfferCategory(c) === 'FREE_ITEM');
          draft.appliedCoupons = existingFreeItem ? [incoming, existingFreeItem] : [incoming];
          break;
        }
        const existingExclusive = existing.find((c: any) => isExclusiveCoupon(c));
        if (existingExclusive && existingExclusive.id !== incoming?.id && incomingCat !== 'FREE_ITEM') {
          break;
        }

        // BOGO and non-exclusive ORDER offers can stack — multiple may be
        // active simultaneously. Stack by id: re-applying the same id
        // overwrites (update), a new id adds alongside existing ones.
        // FREE_ITEM / FREE_DELIVERY remain single-slot: applying one always
        // replaces the existing coupon in that category slot.
        if (incomingCat === 'BOGO' || incomingCat === 'ORDER') {
          draft.appliedCoupons = [
            ...existing.filter((c: any) => c?.id !== incoming?.id),
            incoming,
          ];
        } else {
          // FREE_ITEM / FREE_DELIVERY — single-slot.
          draft.appliedCoupons = [
            ...existing.filter((c: any) => getOfferCategory(c) !== incomingCat),
            incoming,
          ];
        }
        break;
      }
          case CLEAR_APPLIED_COUPON: {
        const filter = action.payload;
        const current = Array.isArray(draft.appliedCoupons) ? draft.appliedCoupons : [];
        if (!filter) {
          // Only mutate if there is actually something to clear
          if (current.length > 0) draft.appliedCoupons = [];
        } else if (filter.category) {
          const filtered = current.filter(
            (c: any) => getOfferCategory(c) !== filter.category
          );
          // Only assign a new array when the filter actually removed something;
          // otherwise Immer would produce a new reference from an identical list,
          // causing dependent useEffects (e.g. the totals effect) to re-fire
          // needlessly and create an infinite API-call loop.
          if (filtered.length !== current.length) draft.appliedCoupons = filtered;
        } else if (filter.id != null) {
          const filtered = current.filter((c: any) => c?.id !== filter.id);
          if (filtered.length !== current.length) draft.appliedCoupons = filtered;
        }
        break;
      }






      default:
        break;
    }
  });
}


